/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * scrollTrigger-splash.js
 *
 * ロード後に実行するアニメーション用
 *
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * 初期設定
 */
/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
import gsap from "gsap";
import scrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(scrollTrigger);

/**
 * actionToSplash
 * 全ページ用スプラッシュアクション
 *━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
function actionToSplash() {
	//var
	var body = document.body;
	var headerLogo = document.getElementById("site-h__logo");
	var headerEntryNav = document.getElementById("site-h_entry-nav");
	var dNavBtn = document.getElementById("d-nav-btn");

	var tl = gsap.timeline({
		defaults: { duration: 1, ease: "power4.out" },
	});

	//to
	tl.to([body], {
		opacity: 1,
		duration: 0.5,
	}).to([headerLogo, headerEntryNav, dNavBtn], {
		translateY: 0,
	});
}

/**
 * actionToPageMove
 * ページ遷移時アクション
 *━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
function actionToPageMove() {
	var maskTl = gsap.timeline({
		defaults: { duration: 0.4, ease: "power4.out" },
	});

	let mask = document.getElementById("mask");

	maskTl.to(mask, {
		opacity: 1,
	});
}

/**
 * actionToSplash
 * 初回読み込み用スプラッシュアクション
 *━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
function actionToFirstSplash() {}

/**
 * actionToSplashHome
 * TOPページ用スプラッシュアクション
 *━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
function actionToSplashHome() {
	var homeTl = gsap.timeline({
		defaults: { duration: 1, ease: "power4.out" },
	});

	//var
	var mvCopyEn = document.querySelectorAll("#mvCopyEn span");
	var mvCopyJp1 = document.querySelectorAll("#mvCopyJp1 span");
	var mvCopyJp2 = document.querySelectorAll("#mvCopyJp2 span");
	var mvVideo = document.getElementById("mvVideo");
	var mvRecruitMove = document.getElementById("mvRecruitMove");

	//set
	gsap.set([mvCopyEn, mvCopyJp1, mvCopyJp2], {
		yPercent: 100,
		opacity: 0,
	});
	gsap.set([mvRecruitMove], {
		scale: 0.5,
		opacity: 0,
	});
	gsap.set([mvVideo], {
		opacity: 0,
	});

	//to
	homeTl
		.to([mvRecruitMove, mvVideo], {
			scale: 1,
			opacity: 1,
			delay: 0.5,
		})
		.to(
			[mvCopyEn],
			{
				yPercent: 0,
				opacity: 1,
				stagger: {
					from: "start",
					amount: 0.2,
				},
			},
			"<"
		)
		.to(
			[mvCopyJp1, mvCopyJp2],
			{
				yPercent: 0,
				opacity: 1,
				stagger: {
					from: "start",
					amount: 0.2,
				},
			},
			"<"
		);
}

/**
 * actionToSplashLower
 * 下層ページ用スプラッシュアクション
 *━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
function actionToSplashLower() {
	var lowerTl = gsap.timeline({
		defaults: { duration: 1, ease: "power4.out" },
	});

	//var
	var pagettlTextParent = document.querySelectorAll("#pagettlTextParent");
	var pagettlTextParentLine = document.querySelectorAll("#pagettlTextParent .line");
	var pagettlTextEn = document.querySelectorAll("#pagettlTextEn .span__create span");
	var pagettlTextDefault = document.querySelectorAll(".default #pagettlText .span__create span");
	var pagettlTextFull = document.querySelectorAll(".full #pagettlText .span__create span");
	var pagettlLead = document.getElementById("pagettlLead");
	var breadcrumb = document.querySelectorAll(".breadcrumb li");
	var ttlMv = document.querySelectorAll("#ttlMv img");
	var ttlMvCover = document.querySelectorAll("#ttlMv .cover");
	var ttlMvFull = document.querySelectorAll("#ttlMvFull img");
	var peopleFile = document.querySelectorAll(".people-file-box");
	var peopleFileInner = document.querySelectorAll(".people__profile__inner");
	var peopleOutlineInner = document.querySelectorAll(".people__outline__inner");

	//set
	gsap.set([breadcrumb], {
		xPercent: 25,
		opacity: 0,
	});
	if (pagettlTextDefault) {
		gsap.set([pagettlTextDefault], {
			yPercent: 100,
			opacity: 0,
		});
	}
	if (pagettlTextFull) {
		gsap.set([pagettlTextFull], {
			scale: 1.5,
			opacity: 0,
		});
	}
	if (pagettlTextParent && pagettlTextParentLine) {
		gsap.set([pagettlTextParent], {
			opacity: 0,
		});
		gsap.set([pagettlTextParentLine], {
			scaleX: 0,
		});
	}
	if (pagettlTextEn) {
		gsap.set([pagettlTextEn], {
			yPercent: 100,
			opacity: 0,
		});
	}
	if (pagettlLead) {
		gsap.set([pagettlLead], {
			yPercent: 100,
			opacity: 0,
		});
	}
	if (ttlMv && ttlMvCover) {
		gsap.set([ttlMv], {
			scale: 1.5,
		});
	}
	if (ttlMvFull) {
		gsap.set([ttlMvFull], {
			scale: 1.2,
			opacity: 0,
		});
	}
	if (peopleFile && peopleFileInner && peopleOutlineInner) {
		gsap.set([peopleFile], {
			scaleX: 0,
			opacity: 0,
		});
		gsap.set([peopleFileInner, peopleOutlineInner], {
			opacity: 0,
		});
	}

	if (window.document.body.classList.contains("our-job-child")) {
		//to
		lowerTl
			.to(
				[pagettlTextParent, pagettlTextFull, ttlMvFull],
				{
					scale: 1,
					opacity: 1,
					delay: 0.5,
					stagger: {
						from: "start",
						amount: 0.2,
					},
				},
				"<"
			)
			.to(
				[pagettlTextParentLine],
				{
					scale: 1,
				},
				"<"
			)
			.to(
				[breadcrumb],
				{
					xPercent: 0,
					opacity: 1,
					stagger: {
						from: "start",
						amount: 0.2,
					},
				},
				"-=0.5"
			);
	} else if (window.document.body.classList.contains("people-child")) {
		lowerTl
			.to(
				[pagettlTextParent, pagettlTextFull],
				{
					scale: 1,
					opacity: 1,
					delay: 0.5,
					stagger: {
						from: "start",
						amount: 0.2,
					},
				},
				"<"
			)
			.to(
				[pagettlTextParentLine],
				{
					scale: 1,
				},
				"<"
			)
			.to(
				[ttlMvFull, peopleFile],
				{
					scale: 1,
					opacity: 1,
				},
				"<"
			)
			.to(
				[peopleFileInner, peopleOutlineInner],
				{
					opacity: 1,
				},
				"-=0.5"
			)
			.to(
				[breadcrumb],
				{
					xPercent: 0,
					opacity: 1,
					stagger: {
						from: "start",
						amount: 0.2,
					},
				},
				"-=0.5"
			);
	} else if (window.document.body.classList.contains("project-story-child")) {
		lowerTl
			.to(
				[pagettlTextParent, pagettlTextFull],
				{
					scale: 1,
					opacity: 1,
					delay: 0.5,
					stagger: {
						from: "start",
						amount: 0.2,
					},
				},
				"<"
			)
			.to(
				[pagettlTextParentLine],
				{
					scale: 1,
				},
				"<"
			)
			.to(
				[ttlMvFull],
				{
					scale: 1,
					opacity: 1,
				},
				"<"
			)
			.to(
				[breadcrumb],
				{
					xPercent: 0,
					opacity: 1,
					stagger: {
						from: "start",
						amount: 0.2,
					},
				},
				"-=0.5"
			);
	} else {
		lowerTl
			.to(
				[pagettlTextParent, pagettlTextParentLine, pagettlTextEn, pagettlTextDefault, pagettlLead],
				{
					yPercent: 0,
					scale: 1,
					opacity: 1,
					delay: 0.5,
					stagger: {
						from: "start",
						amount: 0.2,
					},
				},
				"<"
			)
			.to(
				[ttlMv],
				{
					scale: 1,
				},
				"<"
			)
			.to(
				[ttlMvCover],
				{
					scaleX: 0,
				},
				"<"
			)
			.to(
				[breadcrumb],
				{
					xPercent: 0,
					opacity: 1,
					stagger: {
						from: "start",
						amount: 0.2,
					},
				},
				"-=0.5"
			);
	}
}

/**
 * Export.
 */
/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
export { actionToSplash };
